module.exports = __webpack_public_path__ + "static/media/camera_yellow.c9605422.svg";